import { AppImages, variantProvider } from '@/app'
import { Icon, Text, View, onContributeStart } from '@/components'
import { motion } from 'framer-motion'

type ContributeButtonProps = {}

export const ContributeButton = (props: ContributeButtonProps) => {
  return (
    <View onClick={onContributeStart} variants={['alignCenter', 'column', 'gap:0.5', 'cursor:pointer']}>
      <motion.div style={styles.animatedWrapper} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
        <Icon debugName='contribute:plus' name={'plus'} style={styles.actionIcon} />
      </motion.div>

      <Text text={'Contribute'} variants={['p2', 'regular', 'color:neutral1']} />
    </View>
  )
}

const BREAKPOINT = 'small'

const styles = variantProvider.createComponentStyle(theme => ({
  actionIcon: {
    maxHeight: 32,
    maxWidth: 32,
    width: '4vw',
    height: '4vw',
    color: theme.colors.neutral1,
    zIndex: 2,
    [theme.media.down(BREAKPOINT)]: {
      width: '10vw',
      height: '10vw',
      maxHeight: 36,
      maxWidth: 36,
    },
  },
  animatedWrapper: {
    display: 'flex',
    ...theme.presets.center,
    ...theme.presets.relative,
    overflow: 'hidden',
    maxWidth: 54,
    maxHeight: 54,
    width: '12vw',
    height: '12vw',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `url(${AppImages.contributeBg})`,
    borderRadius: theme.borderRadius.rounded,
  },
}), true)
